import { render, staticRenderFns } from "./onlinePaymentInfo.vue?vue&type=template&id=0ed23bfc&"
import script from "./onlinePaymentInfo.vue?vue&type=script&lang=js&"
export * from "./onlinePaymentInfo.vue?vue&type=script&lang=js&"
import style0 from "./onlinePaymentInfo.vue?vue&type=style&index=0&id=0ed23bfc&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports